import { render } from "./PointsOfInterestPreview.vue?vue&type=template&id=7f116b4d&scoped=true"
import script from "./PointsOfInterestPreview.vue?vue&type=script&lang=js"
export * from "./PointsOfInterestPreview.vue?vue&type=script&lang=js"

import "./PointsOfInterestPreview.vue?vue&type=style&index=0&id=7f116b4d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f116b4d"]])

export default __exports__